module.exports = __webpack_public_path__ + "static/media/6460.73c4fc98.jpg";